import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GroupsComponent } from './groups.component';
import { GroupRolesComponent } from './group-roles/group-roles.component';

const routes: Routes = [
  {
    path: '',
    component: GroupsComponent
  },
  {
    path: ':groupName',
    component: GroupRolesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupsRoutingModule {
}
